export enum ReportsPageViewTypeEnum {
  Table = "Table",
  Diagram = "Diagram",
}
